cockpitApp.filter('camelCaseToSentenceCase', function() {
  return function(text) {
    if (text !== undefined) {
      var result = text.replace( /([A-Z])/g, " $1" );

      return result.charAt(0).toUpperCase() + result.slice(1);
    }
  }
});
